import { useContext } from 'react';
import { CoreDispatchesContext } from '../contexts/dispatches';
import { CoreAppDispatches } from '../redux/core-app-state/types';

export const useCoreAppDispatches = () : CoreAppDispatches => {
  return useContext(CoreDispatchesContext);
};
